import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgendamentosService } from 'src/app/services/agendamentos.service';
import { AuthService } from 'src/app/services/auth.service';
import { ServerUrlService } from 'src/app/services/server-url.service';

@Component({
  selector: 'app-associar-paciente-layout',
  templateUrl: './associar-paciente-layout.component.html',
  styleUrls: ['./associar-paciente-layout.component.scss']
})
export class AssociarPacienteLayoutComponent implements OnInit {

  agendamento: any
  integracaoId: number = 0
  agendaTipo: string = '' // exames | consulta | cs | am | ag
  usuarioId: number = 0
  wentError: boolean = false

  constructor(
    private activatedRoute: ActivatedRoute,
    private agendamentosService: AgendamentosService,
    private serverUrl: ServerUrlService,
    private auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    const host = this.auth.decryptedData.host

    const client = this.serverUrl.name

    console.log(host)
    console.log(client)

    if (host !== client) {
      this.router.navigateByUrl(`/${host}`)
      return
    }

    this.integracaoId = parseInt(this.activatedRoute.snapshot.paramMap.get(
      'agendamentoIntegracaoId'
    ))

    this.agendaTipo = this.activatedRoute.snapshot.paramMap.get(
      'agendaTipo'
    )

    this.agendamentosService.buscarAgendamentoPorIntegracaoId(this.agendaTipo, this.integracaoId).subscribe({
      next: (value) => {
        this.agendamento = value
        this.usuarioId = this.agendamento.usuario_id
      },
      error: () => {
        this.wentError = true
      }
    })
  }

}
